module.exports = __webpack_public_path__ + "media/images/digivent/avatars/AVATAR-18-e50896c55881153c38a2b79838202546.png";